const config = {
    attachement: true,
    videoDuaration: 40,
    audioDuaration: 60,
    fileSize: 1024 * 2,
    imageFileSize: 1024 * 2,
    videoFileSize: 1024 * 2,
    audioFileSize: 1024 * 2,
    documentFileSize: 1024 * 2,
    maxAllowedMediaCount: 5,
    maximumAllowedUsersToForward: 5,
    maximumCharForwardPopUp: 60,
    internetErrorMessage: 'Please check your Internet connection',
    helpUrl: 'https://hawkeye.contus.us/delete_account',
    demoUrl: 'localhost',
    boxLayout: true,
    reportMembers: 5,
};
export default config;
